"use strict";
/*
 * Created on 29.06.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Filter that can be used to query Window search index.
 * @author Radek Beran
 */


var WindowSearchFilter =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowSearchFilter, _DomainObject_1$Domai);

  /**
   * @param years
   * @param weeks
   * @param search
   * @param portfolios
   * @param promotionWeekType
   * @param promotionSelect
   * @param storeSpecifications
   * @param windowStates
   * @param windowTypeIds
   * @param windowThemeIds
   * @param checkPromotionValidity if true, promotion validity, not validity of windows, is checked against given years and weeks
   */
  function WindowSearchFilter(years, weeks, search, portfolios, // Promotion
  promotionWeekType, promotionSelect, storeSpecifications, // Window
  windowStates, windowTypeIds, windowThemeIds, checkPromotionValidity) {
    var _this;

    _classCallCheck(this, WindowSearchFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowSearchFilter).call(this));
    _this.years = years;
    _this.weeks = weeks;
    _this.search = search;
    _this.portfolios = portfolios;
    _this.promotionWeekType = promotionWeekType;
    _this.promotionSelect = promotionSelect;
    _this.storeSpecifications = storeSpecifications;
    _this.windowStates = windowStates;
    _this.windowTypeIds = windowTypeIds;
    _this.windowThemeIds = windowThemeIds;
    _this.checkPromotionValidity = checkPromotionValidity;
    return _this;
  }

  _createClass(WindowSearchFilter, [{
    key: "toString",
    value: function toString() {
      return utils_1.Utils.safeStringify({
        years: this.years !== undefined ? this.years.toArray() : [],
        weeks: this.weeks !== undefined ? this.weeks.toArray() : [],
        search: this.search,
        portfolios: this.portfolios !== undefined ? this.portfolios.toArray() : [],
        promotionWeekType: this.promotionWeekType,
        promotionSelect: this.promotionSelect,
        storeSpecifications: this.storeSpecifications !== undefined ? this.storeSpecifications.toArray() : [],
        windowStates: this.windowStates !== undefined ? this.windowStates.toArray() : [],
        windowTypeIds: this.windowTypeIds !== undefined ? this.windowTypeIds.toArray() : [],
        windowThemeIds: this.windowThemeIds !== undefined ? this.windowThemeIds.toArray() : [],
        checkPromotionValidity: this.checkPromotionValidity
      });
    }
  }]);

  return WindowSearchFilter;
}(DomainObject_1.DomainObject);

exports.WindowSearchFilter = WindowSearchFilter;
WindowSearchFilter.EMPTY = new WindowSearchFilter();